import { render, staticRenderFns } from "./sellertest.vue?vue&type=template&id=522bb0de&"
import script from "./sellertest.vue?vue&type=script&lang=js&"
export * from "./sellertest.vue?vue&type=script&lang=js&"
import style0 from "./sellertest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports